import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    ISupporterEditBuyerProfileClient,
} from 'interfaceAdapter/gatewaySchemas/ISupporterEditBuyerProfileClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/supporter/edit/buyer/profile`;

export class SupporterEditBuyerProfileClient implements ISupporterEditBuyerProfileClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, buyerId, buyer } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-S': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({ ...buyer, buyer_id: buyerId });

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
